"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ButtonDestroy;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ButtonDestroy(_ref) {
  var handleDestroy = _ref.handleDestroy,
      notificationId = _ref.notificationId;

  return _react2.default.createElement("button", {
    type: "button",
    className: "pull-right close-notification-button icon-cg-close",
    onClick: handleDestroy.bind(null, notificationId)
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/ButtonDestroy.js
// module id = 2235
// module chunks = 0